import React, {useEffect, useState} from "react";
import Header from "../../components/Header";
import OrderIdle from "../../components/OrderIdle";
import "./style.scss";
import CombinationArticleAddons from "../../components/CombinationArticleAddons";
import {useParams} from "react-router";
import menuStore from "../../stores/menu";
import {Combination, MenuItem, MenuItemCombination} from "../../@types/stores/menu";
import FooterForCombinations from "../../components/FooterForCombinations";

const CombinationAddonPage = () => {
    let params = useParams()

    const [combination, setCombination] = useState<MenuItemCombination | null>(null);
    const [step, setStep] = useState<Combination | null>(null);
    const [article, setArticle] = useState<MenuItem | null>(null);

    useEffect(() => {
        getItem(params.id)
    }, [params.id, params.stepId]);

    const getItem = async (id: string | undefined) => {
        if (!menuStore.menu)
            await menuStore.getMenu();

        const category = params.category ? +params.category : 0;
        menuStore.changeCategory(category);

        const subCategory = params.subCategory ? +params.subCategory : 0;
        menuStore.changeSubCategory(subCategory);


        if (id) {
            const _combination = menuStore.getCombinationById(+id);
            if (_combination) {
                setCombination(_combination);
                const _step = _combination.combination.find(x => x.id === +(params.stepId || -1));
                if (_step) {
                    setStep(_step);
                    const _item = _step.articles.find(x => x.article.id === +(params.articleId || -1));
                    if (_item?.article?.id)
                        setArticle(_item.article);
                }
            }
        }
    }

    if (!article || !combination || !step) return null;

    return <div className="CombinationAddonPage">
        <Header />
        <CombinationArticleAddons item={article} combination={combination} step={step} menuId={+(params.category || -1)} subMenuId={+(params.subCategory || -1)} />
        <FooterForCombinations />
        <OrderIdle />
    </div>
}

export default CombinationAddonPage;
